import { render } from "./Workflows.vue?vue&type=template&id=0f54d776&scoped=true"
import script from "./Workflows.vue?vue&type=script&lang=js"
export * from "./Workflows.vue?vue&type=script&lang=js"

import "./Workflows.vue?vue&type=style&index=0&id=0f54d776&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f54d776"]])

export default __exports__